import dynamic from 'next/dynamic';

const Layout = dynamic(() => import('../../hoc/staticLayout'), {loading: () => <></>, ssr: true});
import LoginLayout from "../../hoc/appLayout";

const DegreeContent = dynamic(() => import('../../components/static/degreePage/degree'), {
    loading: () => <></>,
    ssr: true
});
import {withRouter} from 'next/router';
import React, {useEffect, useState} from "react";
import Store from '../../store';
import {getAllPrograms, getAllHeardSources} from '../../api/register';

import {getIslamicStudies} from "../../api/islamic_studies";
import {getIslamicLeaderships} from "../../api/islamic_leaderships";
import {getIslamicChaplaincies} from "../../api/islamic_chaplaincies";
import {getIslamicEducations} from "../../api/islamic_educations";
import {getIslamicTheologies} from "../../api/islamic_theologies";
import {getIslamicDoctor} from "../../api/islamic_doctor";

function DegreeProgram(props) {
    const {userAuth} = Store.getState();
    const [isLogin, setIsLogin] = useState(false);

    useEffect(() => {
        if (userAuth.authenticated && userAuth.token) {
            setIsLogin(true);
        }
    }, []);

    const meta = {
        title: "Degree programs | Choose a degree | Choose a concentration | Masters of Arts in Regligion | Masters of Divinity in Islamic Chaplaincy | Bayan",
        description: "Degree programs equip men and women with a firm grounding in Islamic thought and cultivates practical skills in a variety of religious contexts and professional settings.",
        route: "degree-programs",
    }

    return (
        <>
            {isLogin ?
                <LoginLayout theme={props.theme} meta={meta}>
                    <DegreeContent
                        router={props.router}
                        islamicData={props.islamicData}
                        islamicLeadershipData={props.islamicLeadershipData}
                        islamicChaplainciesData={props.islamicChaplainciesData}
                        islamicEducationData={props.islamicEducationData}
                        islamicTheologiesData={props.islamicTheologiesData}
                        programs={props.programs}
                        sources={props.heardSources}/>
                </LoginLayout>
                :
                <Layout theme={props.theme} meta={meta}>
                    <DegreeContent
                        router={props.router}
                        islamicData={props.islamicData}
                        islamicLeadershipData={props.islamicLeadershipData}
                        islamicChaplainciesData={props.islamicChaplainciesData}
                        islamicEducationData={props.islamicEducationData}
                        islamicTheologiesData={props.islamicTheologiesData}
                        islamicDoctorData={props.islamicDoctorData}
                        programs={props.programs}
                        sources={props.heardSources}/>
                </Layout>}

        </>
    );
}

// export async function getStaticProps() {
// 	// You can use any data fetching library
// 	const programs = await getAllPrograms();
// 	const heardSources = await getAllHeardSources();
// 	return {
// 		props: {
// 			programs: programs || null,
// 			heardSources: heardSources || null,
// 		},
// 	}
// }

export async function getServerSideProps(ctx) {
    const programs = await getAllPrograms();
    const heardSources = await getAllHeardSources();
    const islamicData = await getIslamicStudies();
    const islamicDoctorData = await getIslamicDoctor();
    const islamicLeadershipData = await getIslamicLeaderships();
    const islamicChaplainciesData = await getIslamicChaplaincies();
    const islamicEducationData = await getIslamicEducations();
    const islamicTheologiesData = await getIslamicTheologies();

    return {
        props: {
            programs: programs || null,
            heardSources: heardSources || null,
            islamicData: islamicData || null,
            islamicLeadershipData: islamicLeadershipData || null,
            islamicChaplainciesData: islamicChaplainciesData || null,
            islamicEducationData: islamicEducationData || null,
            islamicTheologiesData: islamicTheologiesData || null,
            islamicDoctorData: islamicDoctorData || null,
        },
    }
}
export default withRouter(DegreeProgram);
